import { getLoc } from '../middleware/getLoc.js'
import { updateSession } from './updateSession.js'

/**
 * @param {string} sessionId
 * @returns {Promise<GetLocResponse>}
 */

export async function runGetLocation(sessionId) {
  try {
    const loc = await getLoc()
    updateSession(sessionId, 'region', loc.region || '')
    updateSession(sessionId, 'ip', loc.remoteAddress || '')
    return loc
  } catch (err) {
    console.error(err)
  }

  return {}
}
